const actions = {
  SEARCH_SUBSCRIPTION_ACTIVITIES: 'SEARCH_SUBSCRIPTION_ACTIVITIES',
  SEARCH_SUBSCRIPTION_ACTIVITIES_END: 'SEARCH_SUBSCRIPTION_ACTIVITIES_END',
  UPDATE_SUBSCRIPTION_ACTIVITY: 'UPDATE_SUBSCRIPTION_ACTIVITY',
  UPDATE_SUBSCRIPTION_ACTIVITY_END: 'UPDATE_SUBSCRIPTION_ACTIVITY_END',
  CREATE_SUBSCRIPTION_ACTIVITY: 'CREATE_SUBSCRIPTION_ACTIVITY',
  CREATE_SUBSCRIPTION_ACTIVITY_END: 'CREATE_SUBSCRIPTION_ACTIVITY_END',
  FIND_SUBSCRIPTION_ACTIVITY: 'FIND_SUBSCRIPTION_ACTIVITY',
  FIND_SUBSCRIPTION_ACTIVITY_END: 'FIND_SUBSCRIPTION_ACTIVITY_END',
  DELETE_SUBSCRIPTION_ACTIVITIES: 'DELETE_SUBSCRIPTION_ACTIVITIES',
  DELETE_SUBSCRIPTION_ACTIVITIES_END: 'DELETE_SUBSCRIPTION_ACTIVITIES_END',

  SEARCH_SUBSCRIPTION_PROGRAM_PRIVILEGE_TICKET: 'SEARCH_SUBSCRIPTION_PROGRAM_PRIVILEGE_TICKET',
  SEARCH_SUBSCRIPTION_PROGRAM_PRIVILEGE_TICKET_END:
    'SEARCH_SUBSCRIPTION_PROGRAM_PRIVILEGE_TICKET_END',
  FIND_SUBSCRIPTION_PROGRAM_PRIVILEGE_TICKET: 'FIND_SUBSCRIPTION_PROGRAM_PRIVILEGE_TICKET',
  FIND_SUBSCRIPTION_PROGRAM_PRIVILEGE_TICKET_END: 'FIND_SUBSCRIPTION_PROGRAM_PRIVILEGE_TICKET_END',

  SEARCH_SUBSCRIPTION_PROGRAM_MEMBER_PRIVILEGE: 'SEARCH_SUBSCRIPTION_PROGRAM_MEMBER_PRIVILEGE',
  SEARCH_SUBSCRIPTION_PROGRAM_MEMBER_PRIVILEGE_END:
    'SEARCH_SUBSCRIPTION_PROGRAM_MEMBER_PRIVILEGE_END',
  FIND_SUBSCRIPTION_PROGRAM_MEMBER_PRIVILEGE: 'FIND_SUBSCRIPTION_PROGRAM_MEMBER_PRIVILEGE',
  FIND_SUBSCRIPTION_PROGRAM_MEMBER_PRIVILEGE_END: 'FIND_SUBSCRIPTION_PROGRAM_MEMBER_PRIVILEGE_END',

  SEARCH_SUBSCRIPTION_PROGRAMS: 'SEARCH_SUBSCRIPTION_PROGRAMS',
  SEARCH_SUBSCRIPTION_PROGRAMS_END: 'SEARCH_SUBSCRIPTION_PROGRAMS_END',
  DELETE_SUBSCRIPTION_PROGRAMS: 'DELETE_SUBSCRIPTION_PROGRAMS',
  DELETE_SUBSCRIPTION_PROGRAMS_END: 'DELETE_SUBSCRIPTION_PROGRAMS_END',
  FIND_SUBSCRIPTION_PROGRAM: 'FIND_SUBSCRIPTION_PROGRAM',
  FIND_SUBSCRIPTION_PROGRAM_END: 'FIND_SUBSCRIPTION_PROGRAM_END',
  CREATE_SUBSCRIPTION_PROGRAM: 'CREATE_SUBSCRIPTION_PROGRAM',
  CREATE_SUBSCRIPTION_PROGRAM_END: 'CREATE_SUBSCRIPTION_PROGRAM_END',
  UPDATE_SUBSCRIPTION_PROGRAM: 'UPDATE_SUBSCRIPTION_PROGRAM',
  UPDATE_SUBSCRIPTION_PROGRAM_END: 'UPDATE_SUBSCRIPTION_PROGRAM_END',
  GET_SUBSCRIPTION_RECEIPT_CONFIGURATION: 'GET_SUBSCRIPTION_RECEIPT_CONFIGURATION',
  GET_SUBSCRIPTION_RECEIPT_CONFIGURATION_ENDED: 'GET_SUBSCRIPTION_RECEIPT_CONFIGURATION_ENDED',
  UPDATE_SUBSCRIPTION_RECEIPT_CONFIGURATION: 'UPDATE_SUBSCRIPTION_RECEIPT_CONFIGURATION',
  UPDATE_SUBSCRIPTION_RECEIPT_CONFIGURATION_ENDED:
    'UPDATE_SUBSCRIPTION_RECEIPT_CONFIGURATION_ENDED',
  GET_SUBSCRIPTION_HANDLING_FEE_CONFIGURATION: 'GET_SUBSCRIPTION_HANDLING_FEE_CONFIGURATION',
  GET_SUBSCRIPTION_HANDLING_FEE_CONFIGURATION_ENDED:
    'GET_SUBSCRIPTION_HANDLING_FEE_CONFIGURATION_ENDED',
  UPDATE_SUBSCRIPTION_HANDLING_FEE_CONFIGURATION: 'UPDATE_SUBSCRIPTION_HANDLING_FEE_CONFIGURATION',
  UPDATE_SUBSCRIPTION_HANDLING_FEE_CONFIGURATION_ENDED:
    'UPDATE_SUBSCRIPTION_HANDLING_FEE_CONFIGURATION_ENDED',
  GET_SUBSCRIPTION_RENEWAL_CONFIGURATION: 'GET_SUBSCRIPTION_RENEWAL_CONFIGURATION',
  GET_SUBSCRIPTION_RENEWAL_CONFIGURATION_ENDED: 'GET_SUBSCRIPTION_RENEWAL_CONFIGURATION_ENDED',
  SEARCH_SUBSCRIPTION_RENEWAL_NOTIFICATION_CONFIGURATIONS:
    'SEARCH_SUBSCRIPTION_RENEWAL_NOTIFICATION_CONFIGURATIONS',
  SEARCH_SUBSCRIPTION_RENEWAL_NOTIFICATION_CONFIGURATIONS_ENDED:
    'SEARCH_SUBSCRIPTION_RENEWAL_NOTIFICATION_CONFIGURATIONS_ENDED',
  UPDATE_SUBSCRIPTION_RENEWAL_CONFIGURATION: 'UPDATE_SUBSCRIPTION_RENEWAL_CONFIGURATION',
  UPDATE_SUBSCRIPTION_RENEWAL_CONFIGURATION_ENDED:
    'UPDATE_SUBSCRIPTION_RENEWAL_CONFIGURATION_ENDED',
  SEARCH_SUBSCRIPTION_PROGRAM_CONTRACTS: 'SEARCH_SUBSCRIPTION_PROGRAM_CONTRACTS',
  SEARCH_SUBSCRIPTION_PROGRAM_CONTRACTS_END: 'SEARCH_SUBSCRIPTION_PROGRAM_CONTRACTS_END',
  SEARCH_SUBSCRIPTION_PROGRAM_CONTRACT_ORDERS: 'SEARCH_SUBSCRIPTION_PROGRAM_CONTRACT_ORDERS',
  SEARCH_SUBSCRIPTION_PROGRAM_CONTRACT_ORDERS_END:
    'SEARCH_SUBSCRIPTION_PROGRAM_CONTRACT_ORDERS_END',
  SEARCH_MEMBER_PRIVILEGE_USAGE_TRANSACTION_RECORDS:
    'SEARCH_MEMBER_PRIVILEGE_USAGE_TRANSACTION_RECORDS',
  SEARCH_MEMBER_PRIVILEGE_USAGE_TRANSACTION_RECORDS_END:
    'SEARCH_MEMBER_PRIVILEGE_USAGE_TRANSACTION_RECORDS_END',
  SUBSCRIPTION_PROGRAM_CONTRACT_ORDER_REFUND: 'SUBSCRIPTION_PROGRAM_CONTRACT_ORDER_REFUND',
  SUBSCRIPTION_PROGRAM_CONTRACT_ORDER_REFUND_END: 'SUBSCRIPTION_PROGRAM_CONTRACT_ORDER_REFUND_END',
  SUBSCRIPTION_PROGRAM_CONTRACT_ORDER_REFUND_BY_MANUALLY:
    'SUBSCRIPTION_PROGRAM_CONTRACT_ORDER_REFUND_BY_MANUALLY',
  SUBSCRIPTION_PROGRAM_CONTRACT_ORDER_REFUND_BY_MANUALLY_END:
    'SUBSCRIPTION_PROGRAM_CONTRACT_ORDER_REFUND_BY_MANUALLY_END',
  GET_SUBSCRIPTION_PROGRAM_CONTRACT_ORDER_REFUND_AMOUNT_INFO:
    'GET_SUBSCRIPTION_PROGRAM_CONTRACT_ORDER_REFUND_AMOUNT_INFO',
  GET_SUBSCRIPTION_PROGRAM_CONTRACT_ORDER_REFUND_AMOUNT_INFO_ENDED:
    'GET_SUBSCRIPTION_PROGRAM_CONTRACT_ORDER_REFUND_AMOUNT_INFO_ENDED',
  CREATE_CREDIT_BY_SUBSCRIPTION_PROGRAM_ORDER: 'CREATE_CREDIT_BY_SUBSCRIPTION_PROGRAM_ORDER',
  CREATE_CREDIT_BY_SUBSCRIPTION_PROGRAM_ORDER_ENDED:
    'CREATE_CREDIT_BY_SUBSCRIPTION_PROGRAM_ORDER_ENDED',
};

export default actions;
